import Title from './Title';
import Section1 from './Section1';
import MesProjets from './MesProjets';
import Contact from './Contact';
import WhoAmI from './WhoAmI';
export default function Home() {
  return (
    <div >
      
     <Title/>
     <Section1/>
     <WhoAmI />
     <MesProjets/>
     <Contact/>
    </div>
  );
}
